module.exports = __webpack_public_path__ + "static/media/snowtify-logo.a74af831.png";